import React, { useEffect, useState , useContext} from "react";
import axios, { AxiosResponse } from "axios";
import { config } from "../../contexts/UrlContext";
import { Table, Dimmer, Loader, Popup, Grid, Button } from 'semantic-ui-react';
import { SettingsContext } from "../../contexts/SettingsContext";
import { toast } from "react-toastify";
import ErrorPage from "../ErrorPage/ErrorPage";
import { chartLabels, chartBackground, chartBorder, Stats } from "./StatsInterface";
import StatsChart from "./StatsChart";
import history from "../../History";
import AuthContext from "../../contexts/AuthContext";
import { getRequest } from "../../services/axiosService";


function TableStats() {
    let searchVal = window.location.search;
    let params = new URLSearchParams(searchVal);
    let id: string = params.get('id')!;

    const { auth } = useContext(AuthContext);


    const [loading, setLoading] = useState<boolean>(true);
    const [stats, setStats] = useState<Stats>();
    const [recordStats, setRecordStats] = useState<number[]>([]);
    const [tableName, setTableName] = useState<string>("");
    
    const { hasStatsPrivileges } = useContext(SettingsContext);

    useEffect(() => {
        async function getData() {
            await getStats();
        }
        getData();
    }, []);


    const getStats = async () => {
        setLoading(true);

        try {
            let response: AxiosResponse = await getRequest(auth, `/Stats/GetTableStats?id=${id}`);

            let data = response.data;

                if (data !== null) {
                    setStats(data.stats);
                    setTableName(data.tableName);

                    let recStat: number[] = [];
                    recStat.push(data.stats.tableDocumentsDownloads);
                    recStat.push(data.stats.tableViewed);
                    recStat.push(data.stats.tableDocumentsViewed);
                    recStat.push(data.stats.tableDocumentsEdited);
                    recStat.push(data.stats.tablePDFRenditionsDownloaded);
                    setRecordStats([...recStat]);  
                }

        } catch (error) {
            console.log(error);
            toast.error(`Unable to get CM2WebShare Table Stats. Please see logs for more info`);
        }
        setLoading(false);
    }

    if (loading) {
        return (
            <Dimmer inverted active={true}>
                <Loader inverted>Loading Table Statistics...</Loader>
            </Dimmer>
        );
    }
    else if (!hasStatsPrivileges) {
        return (
            <ErrorPage title="Access Denied" message="You do not have access to the Statistics Page" />
        )
    }
    else {
        return (
            <div className="ui container" style={{ borderBottom: "0", maxWidth: "100%", marginTop: 10 }} id="stats">
                <div className="header blue headerStyleBlue" style={{ marginTop: 20 }}>{tableName} Statistics</div>
                <div className="subtitle" style={{ marginLeft: 10, marginBottom: 10 }}>View refined usage statistics for a the table</div>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={13}>
                            <StatsChart recordStats={recordStats} labels={chartLabels}
                            backgroundColours={chartBackground} borderColours={chartBorder} label="Total Statistics" />
                        </Grid.Column>
                        <Grid.Column width={3}>
                            <Table id="homeTable" style={{ marginLeft: 10 }}>
                                <Table.Header>
                                    <Table.Row>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell><Popup content={`Total amount of documents downloaded for '${tableName}' table`} position='top center' trigger={<span>Downloads Made</span> } /></Table.Cell>
                                        <Table.Cell>{stats?.tableDocumentsDownloads}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><Popup content={`Total amount of times '${tableName}' table has been viewed`} position='top center' trigger={<span>Table Views</span>} /></Table.Cell>
                                        <Table.Cell>{stats?.tableViewed}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><Popup content={`Total amount of document views on the '${tableName}' table via CM Launcher`} position='top center' trigger={<span>Document Views</span>} /></Table.Cell>
                                        <Table.Cell>{stats?.tableDocumentsViewed}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><Popup content={`Total amount of edited completed on document on the '${tableName}' table via CM Launcher`} position='top center' trigger={<span>Edits to Documents</span>} /></Table.Cell>
                                        <Table.Cell>{stats?.tableDocumentsEdited}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><Popup content={`Total amount of PDF Renditions that have been downloaded for the '${tableName}' table via CM Launcher`} position='top center' trigger={<span>PDF Renditions Downloaded</span>} /></Table.Cell>
                                        <Table.Cell>{stats?.tablePDFRenditionsDownloaded}</Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                            <Button style={{ marginLeft: 10 }} onClick={() => history.push("/CM2WebShare/Statistics")} >Back to Statistics</Button>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

export default TableStats;